import React from 'react'
import { TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'

const Infrapay = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    return (
        <>
            <div className="mb-3">
                <label className="label-custom bs-color-b">Nome do Titular da Conta Infrapay</label>
                <TextField
                    error={(error.infrapay_name_holder) && true}
                    value={account.infrapay_name_holder || ''}
                    placeholder="Nome Completo do Titular da conta Infrapay"
                    onChange={e => {
                        dispatch(change({infrapay_name_holder: e.target.value}))
                        if (error.infrapay_name_holder && delete error.infrapay_name_holder);
                    }}
                />

                {(error.infrapay_name_holder) &&
                    <strong className="text-danger">{error.infrapay_name_holder[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Client ID</label>
                <TextField
                    error={(error.infrapay_client_id) && true}
                    value={account.infrapay_client_id || ''}
                    onChange={e => {
                        dispatch(change({infrapay_client_id: e.target.value}))
                        if (error.infrapay_client_id && delete error.infrapay_client_id);
                    }}
                />

                {(error.infrapay_client_id) &&
                    <strong className="text-danger">{error.infrapay_client_id[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Client Secret</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.infrapay_client_secret) && true}
                    value={account.infrapay_client_secret || ''}
                    onChange={e => {
                        dispatch(change({infrapay_client_secret: e.target.value}))
                        if (error.infrapay_client_secret && delete error.infrapay_client_secret);
                    }}
                />

                {(error.infrapay_client_secret) &&
                    <strong className="text-danger">{error.infrapay_client_secret[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Chave Pix</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.infrapay_pix_key) && true}
                    value={account.infrapay_pix_key || ''}
                    onChange={e => {
                        dispatch(change({infrapay_pix_key: e.target.value}))
                        if (error.infrapay_pix_key && delete error.infrapay_pix_key);
                    }}
                />

                {(error.infrapay_pix_key) &&
                    <strong className="text-danger">{error.infrapay_pix_key[0]}</strong>
                }
            </div>
        </>
    )
}


export default Infrapay